import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import { TransportadoraTypes } from './transportadoraAction';
import { defaultReducer } from 'app/store/defaultReducer';

export const initialState = createStateTool({
  carregandoRegistro: false,
  carregandoRegistros: false,
  cadastrar: false,
  visualizar: false,
  registro: {
    id: undefined,
    pessoa: {
      nome: undefined,
      tipoPessoa: 'JURIDICA',
      pessoaJuridica: {
        cnpj: undefined,
        indicadorInscricaoEstadual: undefined,
        inscricaoEstadual: undefined,
        inscricaoMunicipal: undefined,
      },
      // contatos: [{ numero: undefined, telefonesAdicionais: [], email: undefined, emailsAdicionais: [] }],
    },
    // endereco: {
    //   cep: undefined,
    //   logradouro: undefined,
    //   numero: undefined,
    //   complemento: undefined,
    //   uf: undefined,
    //   cidade: undefined,
    //   bairro: undefined,
    //   referencia: undefined,
    // },
  },
  page: { number: 0, size: 0, totalElements: 0, sort: 'pessoa.nome,asc', content: [] },
  selecionados: [],
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
  mensagem: undefined,
  requestParams: { page: 0, size: 15, sort: 'pessoa.nome,asc', q: '' },
  filtroAvancado: {
    nome: undefined,
    cnpj: undefined,
    uf: undefined,
    email: undefined,
    cidade: undefined,
  },

});

function reducer(state, action, types) {
  const { type, payload = {} } = action;

  switch (type) {

    case TransportadoraTypes.SET_FILTRO_AVANCADO: {
      return {
        ...state,
        filtroAvancado: action.payload,
      };
    }
    case TransportadoraTypes.FECHAR_MODAL: {
      return {
        ...state,
        buscaAvancada: false,
        cadastrar: false,
        visualizar: false,
      };
    }
    case TransportadoraTypes.INITIAL_STATE: {
      return { ...initialState };
    }
    case TransportadoraTypes.MENSAGEM: {
      return { ...state, mensagem: payload };
    }
    case TransportadoraTypes.BUSCAR_REGISTROS: {
      return { ...state, ...payload };
    }
    case TransportadoraTypes.CADASTRAR_REGISTRO: {
      return { ...state, visualizar: false, cadastrar: true, registro: initialState.registro };
    }
    case TransportadoraTypes.REMOVER_REGISTROS: {
      return { ...state };
    }
    case TransportadoraTypes.VISUALIZAR_REGISTRO: {
      return { ...state, visualizar: true, cadastrar: false, registro: payload };
    }
    case TransportadoraTypes.EDITAR_REGISTRO: {
      return { ...state, visualizar: false, cadastrar: true, registro: payload };
    }
    case TransportadoraTypes.SELECIONADOS: {
      return { ...state, selecionados: payload };
    }
    case TransportadoraTypes.TIPO_SELECAO: {
      return { ...state, tipoSelecao: payload };
    }
    case TransportadoraTypes.CARREGANDO_REGISTROS: {
      return { ...state, carregandoRegistros: payload };
    }
    case TransportadoraTypes.CARREGANDO_REGISTRO: {
      return { ...state, carregandoRegistro: payload };
    }
    case TransportadoraTypes.FECHAR_MODAL_CADASTRO: {
      return { ...state, cadastrar: false, registro: initialState.registro };
    }
    case TransportadoraTypes.FECHAR_MODAL_VISUALIZACAO: {
      return { ...state, visualizar: false, registro: initialState.registro };
    }
    case TransportadoraTypes.ERRO:
    case TransportadoraTypes.SUCESSO: {
      return {
        ...state,
        ...payload,
      };
    }
    case TransportadoraTypes.REQUEST_PARAMS: {
      return {
        ...state,
        requestParams: { ...state.requestParams, ...payload },
      };
    }
    default: {
      return defaultReducer(state, action, types);
    }
  }
}

export const transportadoraReducer = createReducerTool(reducer, TransportadoraTypes);
